import { Html, html, View } from 'rune-ts';
import { DropdownDownIcon } from '@services/MarppleShop/renderApp/components/atoms/Icon';
import klass from './DropdownView.module.scss';
import { typo } from '@services/MarppleShop/shared/typography/typo';
import { htmlIf } from '@services/MarppleShop/shared/util';

export interface DropdownViewProps {
  readonly title: string;
  is_opened?: boolean;
  title_class?: string;
  container_class?: string;
  readonly contentView: View | Html;

  /**
   * @default true
   */
  readonly show_arrow?: boolean;
}

export class DropdownView extends View<DropdownViewProps> {
  private is_open = this.data.is_opened || false;

  override template() {
    return html`
      <div
        class="${klass.dropdown_container} ${this.data.container_class || ''} ${htmlIf(
          klass.is_hidden,
          !this.is_open,
        )}"
      >
        <button class="${klass.dropdown_toggle_btn} ${typo('12_bold')}">
          <span class="${this.data.title_class || ''}">${this.data.title}</span>
          ${!this.data.show_arrow
            ? ''
            : html`<span class="${klass.dropdown_icon}">${DropdownDownIcon}</span>`}
        </button>
        <div class="${klass.dropdown_content}">${this.data.contentView}</div>
      </div>
    `;
  }

  protected override onRender(): void {
    super.onRender();

    this.delegate('click', `.${klass.dropdown_toggle_btn}`, () => {
      this.is_open = !this.is_open;
      const container_el = this.element();
      container_el.classList.toggle(klass.is_hidden);
    });
  }

  public open(): void {
    if (!this.is_open) {
      this.is_open = true;
      this.element().classList.add(klass.is_opened);
    }
  }

  public close(): void {
    if (this.is_open) {
      this.is_open = false;
      this.element().classList.remove(klass.is_opened);
    }
  }

  public toggle(): void {
    this.is_open = !this.is_open;
    this.element().classList.toggle(klass.is_opened);
  }

  public isOpen(): boolean {
    return this.is_open;
  }
}
